import { v4 as uuidv4 } from "uuid";
import {
  VITE_PAYPAL_FRAUDNET_ID,
  VITE_PAYPAL_SANDBOX,
} from "@/config/constants";
import { loadScript } from "@/utils/general";
import { CustomNotifyService } from "@/services/CustomNotifyService";

const notifyService = new CustomNotifyService();

export function loadScriptPaypal(isTransaction: boolean = false) {
  loadScriptFcnsPaypal(isTransaction);
  const script = "https://c.paypal.com/da/r/fb.js";

  // Promesas para los dos scripts
  const scriptPromises = [loadScript(script)];

  // Ejecutar las promesas y validar que ambos scripts se cargaron
  Promise.all(scriptPromises)
    .then(() => {
      console.log("Script Paypal");
    })
    .catch((reason) => {
      console.log("Error:", reason);
      notifyService.getNotification({
        type: "error",
        title: `Ocurrio un error al carga la información`,
        text: `Ocurrio un error al carga la información, favor de recargar la página`,
        time: 3000,
      });
    });
}

export async function loadScriptFcnsPaypal(isTransaction: boolean) {
  if (typeof document === "undefined") {
    return;
  }
  // Delete script previous
  const fncls = "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99";
  const exists = document.querySelector(`script[fncls="${fncls}"]`);
  if (exists) {
    exists.remove();
  }

  const scriptFncls = document.createElement("script");
  scriptFncls.type = "application/json";
  scriptFncls.setAttribute("fncls", fncls);
  const uniqueId = uuidv4();
  const { store } = await import("@/store");
  if (isTransaction) {
    store.commit("checkoutTransaction/setTrackingId", uniqueId);
  } else {
    store.commit("checkout/setTrackingId", uniqueId);
  }

  // Contenido JSON del script
  const jsonData = {
    f: uniqueId,
    s: VITE_PAYPAL_FRAUDNET_ID,
    sandbox: VITE_PAYPAL_SANDBOX,
  };

  scriptFncls.text = JSON.stringify(jsonData);
  document.body.appendChild(scriptFncls);
}
